/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import Cards from '../../../../common/components/card/Card';
import './Closed.css';
import DashboardList from '../../../../common/components/list/List';
import {
  isIos, isRu, isNullEmptyOrUndefined, isSu,
} from '../../../../common/services/commonService.js';
import {
  ProjectType, commonColumns, iosEndDate, ruSuAccepted,
} from '../Dashboard';
import { useAppSelector } from '../../../../store/hooks';

interface ClosedProps {
    closedProjects: any[]
    handleProjectClick: (value: any, type: ProjectType) => void;
}

const Closed = ({
  closedProjects, handleProjectClick,
}: ClosedProps) => {
  const [columnData, setColumnData] = useState<any[]>([]);
  const gridListFlag = useAppSelector((state) => state?.dashboardReducer?.gridListFlag);
  const showIosEndDate = (project: any) => {
    if (isIos()) {
      return false;
    }
    return (isNullEmptyOrUndefined(project.parentProjectEndDate) ? false
      : project.parentProjectEndDate);
  };

  const buildColumnData = () => {
    const tempColumnData = [...commonColumns];
    if (isIos() === true || isRu() === true) {
      tempColumnData.push(ruSuAccepted);
      setColumnData(tempColumnData);
    }
    if (isRu() === true) {
      tempColumnData.splice(4, 0, iosEndDate);
      setColumnData(tempColumnData);
    }
    if (isSu()) {
      setColumnData(tempColumnData);
    }
  };

  useEffect(() => {
    buildColumnData();
  }, []);

  return (
    <div>
      {closedProjects?.length > 0
        ? gridListFlag === true
          ? (
            <div className="projectsContentWrapper">
              {closedProjects?.map((project) => (
                <Cards
                  key={project.projectId}
                  cardKey={project.projectId}
                  name={project.projectName}
                  images={project?.itemImageUrl}
                  startDate={project.projectStartDate}
                  endDate={project.projectEndDate}
                  iosEndDate={showIosEndDate(project)}
                  hfb={project.hfbNos}
                  items={project.itemCount}
                  suAccepted={isNullEmptyOrUndefined(project.accepted) ? false : project.accepted}
                  onClick={() => handleProjectClick(project, ProjectType.CLOSED)}
                />
              ))}
            </div>
          ) : (
            <DashboardList
              projectData={closedProjects}
              columnData={columnData}
              onRowClick={handleProjectClick}
            />
          ) : null}
    </div>
  );
};

export default Closed;
